import { useMemo } from 'react'
import { Outlet } from 'react-router-dom'
import { ConfigProvider, Layout, theme } from "antd"
import { HeaderComponent } from "./HeaderComponent.tsx"
import { Modals } from "./Modals.tsx"
import { useDarkMode } from "../hooks/useDarkMode.tsx"
import { useQueryInvalidationSubscription } from "../hooks/useQueryInvalidationSubscription.tsx"
import { getAntdTheme } from "../theme/antdTheme.ts"

const { Content } = Layout
const { useToken } = theme

export const LayoutComponent = () => {
    const { token } = useToken()
    const { contextHolder } = useQueryInvalidationSubscription()
    const { darkModeEnabled } = useDarkMode()

    const themeConfig = useMemo(() => getAntdTheme(darkModeEnabled), [darkModeEnabled])

    return (
        <ConfigProvider theme={themeConfig}>
            {contextHolder}
            <Layout style={{
                height: '100vh', background: token.colorBgBase, width: '100%', display: 'flex', overflow: 'hidden'
            }}>
                <Layout>
                    <HeaderComponent />
                    <Content
                        className="scroll"
                        style={{ overflow: 'auto', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                    >
                        <Outlet/>
                    </Content>
                    <Modals />
                </Layout>
            </Layout>
        </ConfigProvider>

    )
}
